import {Injectable} from '@angular/core';

import {TreeListViewEnum} from '../../models/enums/TreeListView.enum';
import {GridStrategy} from './models/interfaces';
import {ReferenceGridStrategyService} from './reference-grid-strategy.service';
import {StakeholderGridStrategyService} from './stakeholder-grid-strategy.service';

@Injectable({
  providedIn: 'root'
})
export class GridContextService {
  private readonly strategyDictionary: Record<TreeListViewEnum, GridStrategy>;
  private currentStrategy: GridStrategy;

  constructor(
    private readonly stakeholderStrategy: StakeholderGridStrategyService,
    private readonly referenceStrategy: ReferenceGridStrategyService
  ) {
    this.strategyDictionary = {
      [TreeListViewEnum.MY_METADATA]: this.stakeholderStrategy,
      [TreeListViewEnum.ALL]: this.referenceStrategy,
      [TreeListViewEnum.CUSTOM_METADATA]: null
    };
  }

  setStrategy(type: string) {
    if (this.strategyDictionary[type]) {
      this.currentStrategy = this.strategyDictionary[type];
    }
  }

  execute(): GridStrategy {
    return this.currentStrategy;
  }
}
